module.exports = __webpack_public_path__ + "assets/img/Best-Affiliate-Program.66e8862f.png";